import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import type { ConsumerProfileResponse } from "@jti/evo-client";
import type { PreparedProfileType, ResponseProfileType } from "@jti/fe-common";
import { DOB_INPUT_DATE } from "@jti/fe-common";

import { convertEvoAddressToCasAddressStored } from "../convertEvoAddressToCasAddressStored";
import { getExtraProfileDataFromCustomAttributes } from "../getExtraProfileDataFromCustomAttributes";

const parseDateToISOString = (date: string): string => {
  dayjs.extend(customParseFormat);
  return dayjs(date, DOB_INPUT_DATE).format();
};

export const prepareUserProfileEvo = (
  profileData: ConsumerProfileResponse["data"],
  meta: ConsumerProfileResponse["meta"]
): PreparedProfileType => {
  return {
    is_age_verified: meta?.is_age_verified ?? false,
    is_pending_email_verification: profileData?.is_pending_email_verification ?? false,

    personalInfo: {
      email: profileData?.consumer?.email ?? "",
      firstname: profileData?.consumer?.first_name ?? "",
      lastname: profileData?.consumer?.last_name ?? "",
      dob: profileData?.consumer?.date_of_birth ?? "",
      telephone: profileData?.consumer?.phone ?? "",
      gender: profileData?.consumer?.gender ?? undefined,
    },
    addresses: profileData?.consumer?.addresses?.map(convertEvoAddressToCasAddressStored) ?? [],
    extra: getExtraProfileDataFromCustomAttributes(profileData?.consumer?.custom_attributes),
    purposes: profileData?.purposes ?? [],
    meta: {
      allow_date_of_birth_update: meta?.allow_date_of_birth_update ?? false,
      allow_name_update: meta?.allow_name_update,
    },
  };
};

export const prepareUserProfile = (userProfileResponse: ResponseProfileType) => {
  const {
    is_age_verified,
    is_pending_email_verification,
    personal_info: { email, firstname, lastname, date_of_birth: dob, phone: telephone, gender },
    addresses,
    extra,
    purposes,
    meta,
  } = userProfileResponse;

  return {
    is_age_verified,
    is_pending_email_verification,
    personalInfo: {
      email,
      firstname,
      lastname,
      dob: dob && parseDateToISOString(dob),
      telephone,
      gender,
    },
    addresses,
    extra,
    purposes,
    meta,
  };
};
